import React from 'react';

/**
 * ErrorScreen — shown when the restaurant JSON fails to load.
 */
export default function ErrorScreen({ message, onRetry }) {
  return (
    <div style={styles.container}>
      <div style={styles.icon}>😕</div>
      <h2 style={styles.title}>Oops!</h2>
      <p style={styles.message}>{message}</p>
      <button
        style={styles.retryBtn}
        onClick={onRetry}
        onMouseEnter={(e) => { e.target.style.transform = 'translateY(-2px)'; }}
        onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; }}
      >
        Try Again
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '2rem',
    textAlign: 'center',
  },
  icon: {
    fontSize: '3.5rem',
    marginBottom: '1rem',
  },
  title: {
    fontFamily: 'var(--font-display)',
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '0.5rem',
  },
  message: {
    fontSize: '0.9rem',
    color: 'var(--text-secondary)',
    marginBottom: '1.5rem',
    maxWidth: '280px',
  },
  retryBtn: {
    padding: '0.75rem 2rem',
    backgroundColor: 'var(--accent)',
    color: 'var(--text-inverse)',
    fontWeight: 600,
    borderRadius: 'var(--radius-full)',
    transition: 'all var(--transition)',
  },
};
